import { Action } from "@ngrx/store";
import { ITankProfile } from "../../interfaces/tankProfile";

export const GET_TANK_PROFILES = "[TankProfile] GetTankProfiles";
export const TANK_PROFILE_FETCHED = "[TankProfile] TankProfileFetched";
export const CREATE_TANK_PROFILE = "[TankProfile] CreateTankProfile";
export const CREATE_TANK_PROFILE_SUCCESS =  "[TankProfile] CreateTankProfileSuccess";
export const CREATE_TANK_PROFILE_FAILURE =  "[TankProfile] CreateTankProfileFailure";
export const SAVE_TANK_PROFILE = "[TankProfile] SaveTankProfile";
export const SAVE_TANK_PROFILE_SUCCESS = "[TankProfile] SaveTankProfileSuccess";
export const SAVE_TANK_PROFILE_FAILURE = "[TankProfile] SaveTankProfileFailure";
export const ACTIVE_TANK_PROFILE_CHANGED = "[TankProfile] TankProfileChanged";
export const UPDATE_TANK_PROFILE_LOCALLY = "[TankProfile] UpdateTankProfileLocally";
export const GRID_COLUMN_MOVED = "[TankProfile] GridColumnMoved";
export const SET_GRID_COLUMN_ORDER = "[TankProfile] SetGridColumnOrder"
export const GRID_COLUMN_VISIBILITY_TOGGLED = "[TankProfile] GridColumnVisibilityToggled";
export const GRID_COLUMN_RESIZED = "[TankProfile] GridColumnResized";
export const UPDATE_CURRENT_TANK_PROFILE = "[CurrentTankProfile] UpdateCurrentTankProfile";
//export const DELETE_TANK_PROFILE = "[TankProfile] DeleteTankProfile";
//export const DELETE_TANK_PROFILE_SUCCESS = "[TankProfile] DeleteTankProfileSuccess";
//export const DELETE_TANK_PROFILE_FAILURE = "[TankProfile] DeleteTankProfileFail";
export const COPY_TANK_PROFILE = "[TankProfile] CopyTankProfile";
export const COPY_TANK_PROFILE_SUCCESS = "[TankProfile] CopyTankProfileSuccess";
export const COPY_TANK_PROFILE_FAILURE = "[TankProfile] CopyTankProfileFail";
export const DELETE_TANK_PROFILE = "[TankProfile] DeleteTankProfile";

export class SetGridColumnOrder implements Action {
  readonly type = SET_GRID_COLUMN_ORDER;

  constructor(public colsByOrder: any[]){ }

}

export class GridColumnMoved implements Action {
  readonly type = GRID_COLUMN_MOVED;

  constructor(public columndId: number,public toIndex: number){}

}

export class GridColumnVisibilityToggled implements Action {
  readonly type = GRID_COLUMN_VISIBILITY_TOGGLED

  constructor(public columnID: number, public visible: boolean){}
}

export class GridColumnResized implements Action {
  readonly type = GRID_COLUMN_RESIZED

  constructor(public columnID: number, public width: number){}
}

export class TankProfileFetched implements Action {
  readonly type = TANK_PROFILE_FETCHED;

  constructor(public tankProfile: ITankProfile) {}
}

export class ActiveTankProfileChanged implements Action {
  readonly type = ACTIVE_TANK_PROFILE_CHANGED;

  constructor(public tankProfile: ITankProfile) {}
}

export class UpdateTankProfileLocally implements Action {
  readonly type = UPDATE_TANK_PROFILE_LOCALLY;

  constructor(public tankProfile: ITankProfile) {}
}

export class UpdateCurrentTankProfile implements Action {
  readonly type = UPDATE_CURRENT_TANK_PROFILE;

  constructor(public tankProfile: ITankProfile) { }
}

export class DeleteTankProfile implements Action {
  readonly type = DELETE_TANK_PROFILE;

  constructor(public tankProfileId: number) {}
}

export type Actions =
  | TankProfileFetched
  | ActiveTankProfileChanged
  | UpdateTankProfileLocally
  | DeleteTankProfile  

export type CurrentTankProfileActions = UpdateCurrentTankProfile | GridColumnMoved | GridColumnVisibilityToggled | SetGridColumnOrder | GridColumnResized;
